import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { AlertCircle, CheckCircle2 } from 'lucide-react';

function EmployeeInfoCard({ employee, appraisal, status }) {
  const getInitials = (name) => {
    if (!name) return '??';
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  const getEmployeeId = () => {
    // Use employee.employee_id from the populated employee object
    if (employee?.employee_id) {
      return employee.employee_id;
    }
    // Fallback: try to get from appraisal.employeeId if it's populated
    if (typeof appraisal.employeeId === 'object') {
      return appraisal.employeeId?.employee_id || 'N/A';
    }
    return 'N/A';
  };

  return (
    <div className="space-y-4">
      {/* Employee Profile Card */}
      <Card>
        <CardContent className="pt-6 flex flex-col items-center text-center">
          <Avatar className="h-20 w-20 mb-3">
            <AvatarFallback className="text-lg bg-primary/10 text-primary font-bold">
              {getInitials(appraisal.employeeName)}
            </AvatarFallback>
          </Avatar>
          <h2 className="font-bold text-lg">{appraisal.employeeName}</h2>
          <p className="text-sm text-muted-foreground">{employee?.designation || appraisal.department}</p>
          <div className="mt-4 w-full space-y-2 text-left text-sm">
            <div className="flex justify-between py-1 border-b dark:border-muted-foreground/40 gap-2">
              <span className="text-muted-foreground shrink-0">ID</span>
              <span className="font-medium text-right truncate max-w-[200px]" title={getEmployeeId()}>
                {getEmployeeId()}
              </span>
            </div>
            <div className="flex justify-between py-1 border-b dark:border-muted-foreground/40">
              <span className="text-muted-foreground">Department</span>
              <span className="font-medium">{appraisal.department}</span>
            </div>
            {employee?.manager && (
              <div className="flex justify-between py-1 border-b dark:border-muted-foreground/40">
                <span className="text-muted-foreground">Manager</span>
                <span className="font-medium">{employee.manager}</span>
              </div>
            )}
            {employee?.joinDate && (
              <div className="flex justify-between py-1 border-b dark:border-muted-foreground/40">
                <span className="text-muted-foreground">Joined</span>
                <span className="font-medium">{employee.joinDate}</span>
              </div>
            )}
            {employee?.lastWorkingDate && (
              <div className="flex justify-between py-1 border-b dark:border-muted-foreground/40">
                <span className="text-muted-foreground">Last Working Date</span>
                <span className="font-medium">{employee.lastWorkingDate}</span>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default EmployeeInfoCard;
